








































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ExamEvaluation from '../../../api/v2/models/exam_evaluation'
import { checkMobile } from '../../utils/utils'

@Component({})
export default class ExamEvaluationComponent extends Vue {
  @Prop({ required: true })
  examEvaluations: ExamEvaluation[]

  @Prop({ default: 0 })
  score: number

  mobile = checkMobile()

  get examEvaluation() {
    return this.examEvaluations.find((item) => item.to >= this.score && item.from <= this.score)
  }
}
